module.exports = __webpack_public_path__ + "img/report-5.4dfae504.jpg";